import { GET_SALESFORCE_URL } from "../constants/urls";

export const qqHomeButton = (setShowLoader, opportunityId) => {
    setShowLoader(true);
    window.location.href = GET_SALESFORCE_URL + opportunityId;
}